import { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import * as yup from "yup";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import SearchableInputsDropdown from '../../components/common/SearchableDropdown';
import alertIcon from "../../assets/dropdown/alert-icon-error.svg";
import arrowIconaccordion from "../../assets/task/up-arrow.png";
import downarrowIconaccordion from "../../assets/task/down-arrow.png";
import trasBin from "../../assets/task/bin.png";
import rePlaceicon from "../../assets/task/user-account.png";
import PlusIcon from "../../assets/task/plusicontask.svg";
import InputsNew from '../../components/common/InputsNew';
import DateSelector from '../../components/common/DateSelector';
import { addDays, addHours, addMinutes, differenceInDays, format, parse } from 'date-fns';
import { showError, showSuccess } from '../../components/common/ToastNotification';
import { ApolloError, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_IDEA_GOAL, GOAL_BY_STATIC_GOAL_ID, GOAL_MASTER_DATA, PROJECTS_BY_EMP_ID, GOAL_DETAILS, GET_RESOURCE_OVERVIEW, GET_ALL_SKILLS, PODS_DATA } from '../../api/query';
import Loader from '../../components/common/Loader';
import { CREATE_GOAL, PATCH_DEFECT } from '../../api/mutation';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadCumb from '../../components/common/Breadcrumb';
import backArrow from "../../assets/task/back_arrow.svg";
import InputsDropdownMultipleSearchSelect from '../../components/common/InputsDropdownMultipleSearchSelect';
import MemberAvailabilityDropdown from '../../components/common/MemberAvailabilityDropdown';
import closeDowpDowniconimg from "../../assets/task/closedropdown-cicon.svg";
import AddMemberToGoalPopup from '../../components/goals/AddMemberToGoalPopup';
import ReplaceMemberPopup from '../../components/goals/ReplaceMemberPopup';
import NotifyPopup from '../../components/dashboard/NotifyPopup';
import { uploadFileDirectly } from "../projects/AddProject";
import viewdeleteIon from "../../assets/task/delete_viewidea4icons.svg";
import viewFileIon from "../../assets/task/vewidea-iconfile.svg";
import ioniconaaddoutline from "../../assets/dashboard/ioniconaaddoutline.svg";
import { LinkItem, LinkManager } from "../../components/customerSuccess/LinkManager";


import { getRoleFromEmployeeRole, getTaskDefaultsByRole } from '../../utils/defectGoalUtils';

// Types for member tasks
interface MemberTask {
    id: string;
    taskType: string;
    taskID: string;
    taskName: string;
    taskChecklist: string[];
    taskSkill: string; // Single skill name for this task
    taskSkillID: string; // Single skill ID for this task
    startTaskDate: string | null;
    durationDays: number;
    durationTimeHour: number;
    durationTimeMinute: number;
    parentTask?: string;
    parentTaskID?: string;
    endDate?: string | null;
}

interface MemberTasks {
    [memberKey: string]: MemberTask[];
}

const AddTask: FunctionComponent = () => {
    const { userInfo } = useAuth()
    const navigate = useNavigate();
    const employeeID = userInfo?.employee_id || '';
    const organizationID = userInfo?.agencies?.id || '';

    const location = useLocation()
    const state = location.state as {
        defectID:string
        ideaID: string
        action:string
        reporter_name:string
        screen_name:string
        agency_name:string
        action_type:string
        description:string
        screen_members:any
        fromPodName?: string
    };

    const [projectOptions, setProjectOptions] = useState<{ key: string; name: string }[]>([]);
    const [goalTypeOptions, setGoalTypeOptions] = useState<{ key: string; name: string }[]>([]);
    const [taskTypeOptions, setTaskTypeOptions] = useState<{ key: string; name: string; type: string }[]>([]);
    const [assignedMemberOptions, setAssignedMemberOptions] = useState<{ key: string; name: string; isAvailable?: boolean; availableHours?: number; totalHours?: number; utilizationPercentage?: number }[]>([]);
    const [goalNameOptions, setGoalNameOptions] = useState<{ key: string; name: string }[]>([]);
    const [parentTaskOptions, setParentTaskOptions] = useState<{ key: string; name: string }[]>([]);
    const [taskChecklist, setTaskChecklist] = useState<{ key: string; name: string }[]>([]);
    const [goalState, setGoalState] = useState("new");
    const [clearSelected, setClearSelected] = useState(false);
    const [clearGoalSelected, setClearGoalSelected] = useState(false);
    const [clearMemberSelected, setClearMemberSelected] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState<any[]>([]);
    const [memberTasks, setMemberTasks] = useState<MemberTasks>({});
    const [expandedMembers, setExpandedMembers] = useState<{ [key: string]: boolean }>({});
    const [hasAutoPopulatedFromIdea, setHasAutoPopulatedFromIdea] = useState(false);
    const [clearTaskTypeSelected, setClearTaskTypeSelected] = useState(false);



    // New state for existing goal functionality (similar to EditGoal)
    const [originalMembers, setOriginalMembers] = useState<any[]>([]);
    const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
    const [showReplaceMemberPopup, setShowReplaceMemberPopup] = useState(false);
    const [memberToReplace, setMemberToReplace] = useState<{ key: string; name: string } | null>(null);
    const [goalTypeData, setGoalTypeData] = useState<any>(null);
    const [editingMember, setEditingMember] = useState<{ key: string; name: string } | null>(null);
    const [taskReplacements, setTaskReplacements] = useState<{ [taskId: string]: string }>({});
    const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
    const [memberToRemove, setMemberToRemove] = useState<{ key: string; name: string; reassignedTaskCount: number } | null>(null);
    const [existingGoalData, setExistingGoalData] = useState<any>(null);

    // Attachments and Links state
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [goalAttachmentView, setGoalAttachmentView] = useState("attachments");
    const [imgUrls, setImgUrls] = useState<string[]>([]);
    const [fileNames, setFileNames] = useState<string[]>([]);
    const [fileTypes, setFileTypes] = useState<string[]>([]);
    const [existingAttachments, setExistingAttachments] = useState<
        { id: string; file_path: string; file_name: string; file_type: string }[]
    >([]);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [validationMessage, setValidationMessage] = useState<string | null>(null);
    const [links, setLinks] = useState<LinkItem[]>([]);

    // Pod state
    const [podOptions, setPodOptions] = useState<{ key: string; name: string }[]>([]);
    const [allPodsData, setAllPodsData] = useState<any[]>([]);
    const [selectedPodId, setSelectedPodId] = useState('');
    const [selectedPodName, setSelectedPodName] = useState('');
    const [pendingAutoSelectPod, setPendingAutoSelectPod] = useState<any>(null);
    const hasAutoSelectedPodRef = useRef(false);

    // Skills state
    const [skillOptions, setSkillOptions] = useState<{ key: string; name: string }[]>([]);
    const [selectedSkills, setSelectedSkills] = useState<any[]>([]);

    // For the agent api
      const [loading,setLoading] = useState<Boolean>(false)


    // Simplified validation schema - no task fields for existing goals
    const addTaskSchema = yup.object().shape({
        projectName: yup.string().required('This field is required'),
        projectID: yup.string().required('This field is required'),
        goalFor: yup.string().required('This field is required'),
        goal: yup.string().required('This field is required'),
        goalType: yup.string().required('This field is required'),
        goalID: yup.string().required('This field is required'),
        goalName: yup.string()
            .test('not-only-whitespace', 'Please add a valid Goal Name', value => !value || value.trim().length > 0)
            .required('This field is required'),
        startGoalDate: yup.string().when('goal', {
            is: 'new',
            then: (schema) => schema.required("This field is required"),
            otherwise: (schema) => schema.nullable(),
        }),
        endGoalDate: yup.string().when('goal', {
            is: 'new',
            then: (schema) => schema.required("This field is required"),
            otherwise: (schema) => schema.nullable(),
        }),
        existingGoalID: yup.string().when('goal', {
            is: 'new',
            then: (schema) => schema.nullable(),
            otherwise: (schema) => schema.required("This field is required"),
        }),
        goalDescription: yup.string()
            .test('not-only-whitespace', 'Please add a valid Goal Description', value => !value || value.trim().length > 0).nullable(),
    });

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        trigger,
        watch,
        control,
        getValues,
        clearErrors
    } = useForm<any>({
        resolver: yupResolver(addTaskSchema),
        defaultValues: {
            goalFor: state?.action == "Training Issue" || state?.action == "Unclear" ?   "Customer Success"  : "Product Development",
            goal: "new",
            projectID:1,
            projectName:"CareBravo",
            startGoalDate:format(new Date(), "yyyy-MM-dd"),
            endGoalDate:format(new Date(), "yyyy-MM-dd"),
            goalDescription:state?.description,
            goalName:`${state?.agency_name} for issue ${state?.screen_name}`
        }
    });

    //api
    const { data: skillData, loading: skillLoading } = useQuery(GET_ALL_SKILLS, {
        fetchPolicy: 'no-cache',
    });

    const [
        getProjectsByEmpID,
        { data: projectsData, loading: projectsDataLoading },
    ] = useLazyQuery(PROJECTS_BY_EMP_ID, {
        fetchPolicy: 'no-cache'
    });

    const [
        getGoalMasterData,
        { data: goalsData, loading: goalsDataLoading },
    ] = useLazyQuery(GOAL_MASTER_DATA, {
        fetchPolicy: 'no-cache'
    });

    const [
        getExistingGoals,
        { data: existingGoalsData, loading: existingGoalsDataLoading },
    ] = useLazyQuery(GOAL_BY_STATIC_GOAL_ID, {
        fetchPolicy: 'no-cache'
    });

    const [createGoal, { loading: createGoalLoading }] = useMutation(CREATE_GOAL, {
        fetchPolicy: 'no-cache',
    })

        // It is for the defect action update
        const [patchDefect, { loading: patchDefectLoading }] = useMutation(PATCH_DEFECT, {
        fetchPolicy: 'no-cache',
    })


    const [
        getIdea,
        { data: ideaData, loading: ideaDataLoading },
    ] = useLazyQuery(GET_IDEA_GOAL, {
        fetchPolicy: 'no-cache'
    });

    const [
        getGoalDetails,
        { data: goalDetailsData, loading: goalDetailsLoading },
    ] = useLazyQuery(GOAL_DETAILS, {
        fetchPolicy: 'no-cache'
    });

    const [
        getResourceOverview,
        { data: resourceOverviewData, loading: resourceOverviewLoading },
    ] = useLazyQuery(GET_RESOURCE_OVERVIEW, {
        fetchPolicy: 'no-cache'
    });

    const [fetchPods, { data: podsQueryData, loading: podsLoading }] = useLazyQuery(PODS_DATA, {
        fetchPolicy: 'no-cache',
    });

   // Skills useEffect
    useEffect(() => {
        if (skillData && skillData.get_all_skills?.skills?.length > 0) {
            const options = skillData.get_all_skills?.skills?.map((skill: any) => ({
                key: skill.id,
                name: skill?.skill_name
            }));
        setSkillOptions(options);

        const defaultSkills = state?.action == "Training Issue" || state?.action == "Unclear" ? ["Leadership","Communication Skills"] : [
        "Python",
        "React",
        "Azure",
        "Web Application Testing",
        ];

     setSelectedSkills(
      options
        .filter((skill:any) => defaultSkills.includes(skill.name))
        .map((skill:any) => ({
          key: skill.key,
          name: skill.name,
          type: skill.type,
        }))
    );
  } 
    }, [skillData])

    // Fetch pods on mount for pod-based member selection
    useEffect(() => {
        if (organizationID) {
            fetchPods({
                variables: {
                    agency_id: parseInt(organizationID),
                    start_date: format(new Date(), "yyyy-MM-dd"),
                    end_date: format(new Date(), "yyyy-MM-dd"),
                },
            });
        }
    }, [organizationID]);

    // Process pods data and store pending auto-select pod
    useEffect(() => {
        if (!podsQueryData?.pods_data?.data) return;
        const pods = podsQueryData.pods_data.data.filter((p: any) => p.pod_name !== 'All Pods');
        setAllPodsData(pods);
        setPodOptions(pods.map((p: any) => ({ key: String(p.pod_id), name: p.pod_name })));

        if (state?.fromPodName && pods.length > 0) {
            const target = pods.find((p: any) =>
                p.pod_name?.toLowerCase() === state.fromPodName!.toLowerCase()
            );
            if (target) {
                setPendingAutoSelectPod(target);
            }
        }
    }, [podsQueryData]);

    // Auto-select pod only once taskTypeOptions is populated (ensures checklists resolve correctly)
    useEffect(() => {
        if (!pendingAutoSelectPod || taskTypeOptions.length === 0 || hasAutoSelectedPodRef.current) return;
        hasAutoSelectedPodRef.current = true;
        handlePodSelectInternal(
            String(pendingAutoSelectPod.pod_id),
            pendingAutoSelectPod.pod_name,
            pendingAutoSelectPod.members || []
        );
    }, [pendingAutoSelectPod, taskTypeOptions]);

    useEffect(() => {
        if (employeeID) {
            getProjectsByEmpID({
                variables: {
                    emp_id: employeeID,
                    organization_id: organizationID
                },
            });
        }
    }, [employeeID])

    useEffect(() => {
        if (projectsData && projectsData.projects_by_emp_id) {
            const projects = projectsData?.projects_by_emp_id || [];
            const options = projects.map((p: any) => ({
                key: p.id,
                name: p.name
            }));
            setProjectOptions(options);
        }
    }, [projectsData]);

    //watch
    const watchProjectName: string = watch('projectName');
    const watchGoal: string = watch('goal')
    const watchGoalFor: string = watch('goalFor')
    const watchGoalType: string = watch('goalType');
    const watchGoalID: string = watch('goalID');
    const watchGoalName: string = watch('goalName');
    const watchStartGoalDate: string = watch('startGoalDate');
    const watchEndGoalDate: string = watch('endGoalDate');

    useEffect(() => {
        if (state?.ideaID) {
            getIdea({
                variables: {
                    id: parseInt(state?.ideaID)
                },
            });
        }
    }, [state])

    // Step 2: When ideaData arrives, set fields (except goalType/goalID)
    useEffect(() => {
        if (ideaData?.get_idea_goal?.status_code === 200) {
            const idea = ideaData.get_idea_goal.idea_goal;

            setValue('projectName', idea.project_name);
            setValue('projectID', idea.project_id);
            setValue('goalName', idea.title);
            setValue('goalDescription', idea.user_input);
            setValue('endGoalDate', idea.expected_closing_date);
            setValue('goalFor', idea.goal_for);

            // Find the selected project
            const selectedProject = projectsData?.projects_by_emp_id.find((project: any) => project.id == idea.project_id);

            // Map members to assignedMemberOptions format
            if (selectedProject && selectedProject.members) {
                const memberOptions = selectedProject?.members?.map((member: any) => ({
                    key: member.employee_id,
                    name: member.member_name,
                }));
                setAssignedMemberOptions(memberOptions);

                // Find if the default employeeID exists in the members list
                const defaultMember = memberOptions?.find((member: any) => member.key == employeeID);

                if (defaultMember) {
                    // Set default assigned member
                    setValue('assignedMemberID', defaultMember.key);
                    setValue('assignedMember', defaultMember.name);
                    trigger('assignedMember');
                } else {
                    // Clear if employeeID not found in members
                    setValue('assignedMemberID', '');
                    setValue('assignedMember', '');
                }
            } else {
                // If no members or project not found, reset the options
                setAssignedMemberOptions([]);
            }

            // Handle attachments from idea
            if (idea?.attachments?.length > 0) {
                const attachments = idea.attachments;
                const fileUrls = attachments.map((attachment: any) => attachment.file_path);
                const fileNames = attachments.map((attachment: any) => attachment.file_name);
                const fileTypes = attachments.map((attachment: any) => attachment.file_type);

                setImgUrls(fileUrls);
                setFileNames(fileNames);
                setFileTypes(fileTypes);

                setExistingAttachments(attachments.map((a: any) => ({
                    id: a.id,
                    file_path: a.file_path,
                    file_name: a.file_name,
                    file_type: a.file_type
                })));
            }

            // Handle links from idea
            if (idea?.links?.length > 0) {
                setLinks(idea?.links?.map((l: any) => ({
                    id: Date.now().toString(),
                    url: l
                })));
            }

            // Handle skills from idea
            if (idea?.skills?.length > 0) {
                const skillOptions = idea?.skills?.map((s: any) => ({
                    key: s?.skill_id,
                    name: s?.skill_name
                }));
                setSelectedSkills(skillOptions);
            }
        }
    }, [ideaData, projectsData]);

    useEffect(() => {
        if (watchProjectName && watchGoalFor) {
            getGoalMasterData({
                variables: {
                    goal_for: watchGoalFor,
                }
            })
        }
    }, [watchProjectName, watchGoalFor])

   useEffect(() => {
        if (goalsData?.goal_master_data?.goals_static) {
            const goals = goalsData.goal_master_data.goals_static.map((goal: any) => ({
                key: goal.id,
                name: goal.name,
                type: goal?.outcome
            }));

            setGoalTypeOptions(goals);
            if(state?.action == "Bug"){
                const bugFind = goals?.find((i:any) => i.name == "Resolve High-priority Bug")
                handleGoalType(bugFind?.key,bugFind?.name)
            }else  if(state?.action == "Enhancement"){
                const bugFind = goals?.find((i:any) => i.name == "Release Feature to Production")
                handleGoalType(bugFind?.key,bugFind?.name)
                setValue("endGoalDate",format(addDays(new Date(), 7), "yyyy-MM-dd") )
            }else  if(state?.action == "Training Issue"){
                const bugFind = goals?.find((i:any) => i.name == "Customer Success")
                handleGoalType(bugFind?.key,bugFind?.name)
            }else  if(state?.action == "Unclear"){
                const bugFind = goals?.find((i:any) => i.name == "Customer Success")
                handleGoalType(bugFind?.key,bugFind?.name)
            }
        }
    }, [goalsData]);

    // Step 4: When BOTH ideaData and goalsData are ready → set goalType/goalID (only for ideas, only once)
    useEffect(() => {
        const idea = ideaData?.get_idea_goal?.idea_goal;
        if (!idea || !goalsData?.goal_master_data || !state?.ideaID || hasAutoPopulatedFromIdea) return;

        setValue('goalType', idea.goals_static_name);
        setValue('goalID', idea.goals_static_id);
        setHasAutoPopulatedFromIdea(true);
    }, [ideaData, goalsData, state?.ideaID, hasAutoPopulatedFromIdea]);

    useEffect(() => {
        if (watchGoalType) {
            const selectedGoal = goalsData.goal_master_data.goals_static.find((goal: any) => goal.name === watchGoalType);

            if (selectedGoal) {
                const tasks = selectedGoal.tasks.map((task: any) => ({
                    key: task.id,
                    name: task.name,
                    type: task?.role_name
                }));
                setTaskTypeOptions(tasks);
                setClearSelected(true)
                setClearTaskTypeSelected(true);

                // Clear only task type related fields for all member tasks
                const updatedMemberTasks: MemberTasks = {};
                Object.keys(memberTasks).forEach(memberKey => {
                    updatedMemberTasks[memberKey] = memberTasks[memberKey].map(task => ({
                        ...task,
                        taskType: '',
                        taskID: '',
                        taskChecklist: []
                    }));
                });
                setMemberTasks(updatedMemberTasks);

                // Reset the clear flag after a short delay
                setTimeout(() => setClearTaskTypeSelected(false), 100);

                // For existing goals, also clear the form task checklist
                setValue('taskChecklist', []);
                setTaskChecklist([]);
            }
        }
    }, [watchGoalType]);



    // Handle goal details data for existing goals
    useEffect(() => {
        if (goalDetailsData?.goal_details?.goal_details) {
            const goalDetails = goalDetailsData.goal_details.goal_details;
            setExistingGoalData(goalDetails);

            // Set goal type data for existing goals
            if (goalsData?.goal_master_data?.goals_static) {
                const goalTypeInfo = goalsData.goal_master_data.goals_static.find((goal: any) =>
                    goal.name === goalDetails.static_goal_type_name
                );
                setGoalTypeData(goalTypeInfo);
            }

            // Handle attachments from existing goal
            if (goalDetails?.attachments?.length > 0) {
                const attachments = goalDetails.attachments;
                const fileUrls = attachments.map((attachment: any) => attachment.file_path);
                const fileNames = attachments.map((attachment: any) => attachment.file_name);
                const fileTypes = attachments.map((attachment: any) => attachment.file_type);

                setImgUrls(fileUrls);
                setFileNames(fileNames);
                setFileTypes(fileTypes);

                setExistingAttachments(attachments.map((a: any) => ({
                    id: a.id,
                    file_path: a.file_path,
                    file_name: a.file_name,
                    file_type: a.file_type
                })));
            } else {
                // Clear attachments if existing goal has none
                setImgUrls([]);
                setFileNames([]);
                setFileTypes([]);
                setExistingAttachments([]);
            }

            // Handle links from existing goal
            if (goalDetails?.links?.length > 0) {
                setLinks(goalDetails?.links?.map((l: any) => ({
                    id: Date.now().toString(),
                    url: l
                })));
            } else {
                // Clear links if existing goal has none
                setLinks([]);
            }

            // Handle skills from existing goal
            if (goalDetails?.skills?.length > 0) {
                const skillOptions = goalDetails?.skills?.map((s: any) => ({
                    key: s?.skill_id,
                    name: s?.skill_name
                }));
                setSelectedSkills(skillOptions);
            } else {
                // Clear skills if existing goal has none
                setSelectedSkills([]);
            }
        }
    }, [goalDetailsData, goalsData]);

    // Call resource overview API when goal dates and project change
    useEffect(() => {
        if (watchStartGoalDate && watchEndGoalDate && watchProjectName && organizationID) {
            // Only clear member selections for NEW goals, not existing goals
            if (watchGoal === "new") {
                setSelectedMembers([]);
                setMemberTasks({});
                setExpandedMembers({});
                setClearMemberSelected(true);
            }

            const input = {
                agency_id: parseInt(organizationID),
                start_date: watchStartGoalDate,
                end_date: watchEndGoalDate,
                project_id: parseInt(getValues('projectID'))
            };

            getResourceOverview({
                variables: {
                    input_data: input
                }
            });

            // Reset clear flag after a short delay (only for new goals)
            if (watchGoal === "new") {
                setTimeout(() => setClearMemberSelected(false), 100);
            }
        }
    }, [watchStartGoalDate, watchEndGoalDate, watchProjectName, organizationID, watchGoal]);

    // Process resource overview data and update member options
    useEffect(() => {
        if (resourceOverviewData?.get_resource_overview?.status_code === 200) {
            const resourceData = resourceOverviewData.get_resource_overview.data;

            if (resourceData?.members && resourceData.members.length > 0) {
                // Sort members: available first, then non-available
                const sortedMembers = [...resourceData.members].sort((a, b) => {
                    if (a.is_available && !b.is_available) return -1;
                    if (!a.is_available && b.is_available) return 1;
                    return 0;
                });

                const memberOptions = sortedMembers.map((member: any) => ({
                    key: member.employee_id,
                    name: `${member.first_name} ${member.last_name}`,
                    isAvailable: member.is_available,
                    availableHours: Math.max(0, member.total_working_hours - member.allocated_working_hours),
                    totalHours: member.total_working_hours,
                    utilizationPercentage: member.utilization_percentage
                }));

                setAssignedMemberOptions(memberOptions);

                // For existing goals, update selected members with availability data
                if (watchGoal === "existing" && selectedMembers.length > 0) {
                    const updatedSelectedMembers = selectedMembers.map(selectedMember => {
                        const memberWithAvailability = memberOptions.find(m => m.key === selectedMember.key);
                        if (memberWithAvailability) {
                            return {
                                ...selectedMember,
                                isAvailable: memberWithAvailability.isAvailable,
                                availableHours: memberWithAvailability.availableHours,
                                totalHours: memberWithAvailability.totalHours,
                                utilizationPercentage: memberWithAvailability.utilizationPercentage
                            };
                        }
                        return selectedMember;
                    });
                    setSelectedMembers(updatedSelectedMembers);
                }

                // If editing member from idea, try to maintain selection
                if (ideaData?.get_idea_goal?.idea_goal) {
                    const defaultMember = memberOptions.find((member: any) => member.key == employeeID);
                    if (defaultMember) {
                        setValue('assignedMemberID', defaultMember.key);
                        setValue('assignedMember', defaultMember.name);
                        trigger('assignedMember');
                    }
                }
            } else {
                // No members available for the selected date range
                setAssignedMemberOptions([]);
            }
        } else if (resourceOverviewData?.get_resource_overview?.status_code !== 200) {
            // API returned an error
            console.error('Resource overview API error:', resourceOverviewData?.get_resource_overview?.message);
            setAssignedMemberOptions([]);
        }
    }, [resourceOverviewData, ideaData, employeeID]);

    // It is used for default selection of members (skipped when pod-based selection is active)
    useEffect(() => {
    if (assignedMemberOptions?.length > 0 && watchGoal === "new" && !selectedPodId) {
        if(state?.screen_members?.length > 0){
      const defaultIds = state?.screen_members

        const selectedData = assignedMemberOptions.filter((item) =>
            defaultIds.includes(String(item.key))
        );

        setSelectedMembers(selectedData);
        setValue("taskAssignedMembers", selectedData);

                    // Initialize tasks for all members
                const newMemberTasks: MemberTasks = {};
                const newExpandedMembers: { [key: string]: boolean } = {};
                selectedData.forEach((member:any) => {
                    newMemberTasks[member.key] = [createNewTask()];
                    newExpandedMembers[member.key] = true;
                });
                setMemberTasks(newMemberTasks);
                setExpandedMembers(newExpandedMembers);
        }
        else if(state?.action == "Training Issue" || state?.action == "Unclear" ){
        const defaultIds = [1000128,1000098,1000138];

        const selectedData = assignedMemberOptions.filter((item) =>
            defaultIds.includes(Number(item.key))
        );
        setSelectedMembers(selectedData);
        setValue("taskAssignedMembers", selectedData);

                    // Initialize tasks for all members
                const newMemberTasks: MemberTasks = {};
                const newExpandedMembers: { [key: string]: boolean } = {};
                selectedData.forEach((member:any) => {
                    newMemberTasks[member.key] = [createNewTask()];
                    newExpandedMembers[member.key] = true;
                });
                setMemberTasks(newMemberTasks);
                setExpandedMembers(newExpandedMembers);
        }else{
        const defaultIds = [1000006,1000108,1000146,1000005];

        const selectedData = assignedMemberOptions.filter((item) =>
            defaultIds.includes(Number(item.key))
        );
        setSelectedMembers(selectedData);
        setValue("taskAssignedMembers", selectedData);

            // Initialize tasks for all members
                const newMemberTasks: MemberTasks = {};
                const newExpandedMembers: { [key: string]: boolean } = {};
                selectedData.forEach((member:any) => {
                    newMemberTasks[member.key] = [createNewTask()];
                    newExpandedMembers[member.key] = true;
                });
                setMemberTasks(newMemberTasks);
                setExpandedMembers(newExpandedMembers);
        }
    }
}, [assignedMemberOptions, watchGoal]);

    // Core pod selection logic — accepts raw pod member data
    const handlePodSelectInternal = (podId: string, podName: string, podMembers: any[]) => {
        setSelectedPodId(podId);
        setSelectedPodName(podName);

        if (!podMembers.length) return;

        const members = podMembers.map((m: any) => ({
            key: String(m.employee_id),
            name: `${m.first_name} ${m.last_name}`,
            isAvailable: m.is_available,
            availableHours: 0,
            totalHours: 0,
            utilizationPercentage: 0,
        }));

        setAssignedMemberOptions(members);
        setSelectedMembers(members);
        setValue('taskAssignedMembers', members);

        const newMemberTasks: MemberTasks = {};
        const newExpandedMembers: { [key: string]: boolean } = {};

        const today = format(new Date(), "yyyy-MM-dd");
        const endDate = calculateEndDate(today, 1, 7, 0);

        // Look up directly from goalsData to avoid depending on taskTypeOptions state timing
        const selectedGoal = goalsData?.goal_master_data?.goals_static?.find(
            (goal: any) => goal.name === watchGoalType
        );

        podMembers.forEach((m: any) => {
            const memberKey = String(m.employee_id);
            const role = getRoleFromEmployeeRole(m.employee_role || '');
            const defaults = getTaskDefaultsByRole(role, state?.screen_name || '');

            const matchingTask = selectedGoal?.tasks?.find((t: any) => t.name === defaults.task_type);
            const taskID = matchingTask ? String(matchingTask.id) : '';
            const allChecklists = matchingTask
                ? matchingTask.checklists.map((i: any) => String(i.id))
                : [];

            // Match skill from member's skill_set against selected goal skills (substring match)
            const matchedSkill = (selectedSkills || []).find((s: any) =>
                (m.skill_set || []).some((ss: string) =>
                    ss.toLowerCase().includes(s.name.toLowerCase()) ||
                    s.name.toLowerCase().includes(ss.toLowerCase())
                )
            );

            newMemberTasks[memberKey] = [createNewTask({
                taskType: defaults.task_type,
                taskID: taskID,
                taskName: defaults.task_name,
                taskChecklist: allChecklists,
                endDate: endDate,
                taskSkill: matchedSkill ? matchedSkill.name : '',
                taskSkillID: matchedSkill ? String(matchedSkill.key) : '',
            })];
            newExpandedMembers[memberKey] = true;
        });

        setMemberTasks(newMemberTasks);
        setExpandedMembers(newExpandedMembers);
    };

    // Pod dropdown handler — looks up raw member data and delegates
    const handlePodSelect = (podId: string, podName: string) => {
        const pod = allPodsData.find((p: any) => String(p.pod_id) === String(podId));
        handlePodSelectInternal(podId, podName, pod?.members || []);
    };

    const handleSelectMembers = (key: any, name: any, type: any) => {
        const allOptions = assignedMemberOptions;

        if (key === "all") {
            if (name === true) {
                // Deselect all
                setSelectedMembers([]);
                setMemberTasks({});
                setExpandedMembers({});
            } else {
                // Select all
                setSelectedMembers(allOptions);
                // Initialize tasks for all members
                const newMemberTasks: MemberTasks = {};
                const newExpandedMembers: { [key: string]: boolean } = {};
                allOptions.forEach(member => {
                    newMemberTasks[member.key] = [createNewTask()];
                    newExpandedMembers[member.key] = true;
                });
                setMemberTasks(newMemberTasks);
                setExpandedMembers(newExpandedMembers);
            }
        } else {
            setSelectedMembers((prev) => {
                const exists = prev.some((item) => item.key == key);
                if (exists) {
                    // REMOVE if already selected
                    setMemberTasks(prevTasks => {
                        const newTasks = { ...prevTasks };
                        delete newTasks[key];
                        return newTasks;
                    });
                    setExpandedMembers(prevExpanded => {
                        const newExpanded = { ...prevExpanded };
                        delete newExpanded[key];
                        return newExpanded;
                    });
                    return prev.filter((item) => item.key != key);
                } else {
                    // ADD if not selected
                    setMemberTasks(prevTasks => ({
                        ...prevTasks,
                        [key]: [createNewTask()]
                    }));
                    setExpandedMembers(prevExpanded => ({
                        ...prevExpanded,
                        [key]: true
                    }));
                    return [...prev, { key, name, type }];
                }
            });
        }
    };

    const createNewTask = (overrides?: Partial<MemberTask>): MemberTask => ({
        id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
        taskType: '',
        taskID: '',
        taskName: '',
        taskChecklist: [],
        taskSkill: '',
        taskSkillID: '',
        startTaskDate: format(new Date(), "yyyy-MM-dd"),
        durationDays: 1,
        durationTimeHour: 7,
        durationTimeMinute: 0,
        endDate: null,
        ...overrides,
    });

    const addTaskToMember = (memberKey: string) => {
        setMemberTasks(prev => ({
            ...prev,
            [memberKey]: [...(prev[memberKey] || []), createNewTask()]
        }));
    };

    const removeTaskFromMember = (memberKey: string, taskId: string) => {
        setMemberTasks(prev => ({
            ...prev,
            [memberKey]: prev[memberKey].filter(task => task.id !== taskId)
        }));
    };

    const updateMemberTask = (memberKey: string, taskId: string, field: keyof MemberTask, value: any) => {
        setMemberTasks(prev => ({
            ...prev,
            [memberKey]: prev[memberKey].map(task =>
                task.id === taskId ? { ...task, [field]: value } : task
            )
        }));
    };

    const toggleMemberAccordion = (memberKey: string) => {
        setExpandedMembers(prev => ({
            ...prev,
            [memberKey]: !prev[memberKey]
        }));
    };

    const calculateEndDate = (startDate: string, durationDays: number, durationHours: number, durationMinutes: number) => {
        if (!startDate || (!durationDays && !durationHours && !durationMinutes)) {
            return null;
        }

        // Parse date parts manually to avoid UTC timezone shift
        const [year, month, day] = startDate.split('-').map(Number);
        const startDateObj = new Date(year, month - 1, day, 0, 0, 0, 0);

        let endDateObj = addMinutes(startDateObj, durationMinutes);
        endDateObj = addHours(endDateObj, durationHours);
        endDateObj = addDays(endDateObj, (durationDays - 1));

        return format(endDateObj, "MM-dd-yyyy");
    };

    function handleSelectProject(key: number, name: string): void {
        setValue('projectID', key)
        setValue('projectName', name)
        trigger('projectName')

        // Clear member options initially - they will be populated by resource overview API
        setAssignedMemberOptions([]);
        setValue('assignedMemberID', '');
        setValue('assignedMember', '');

        setValue('goalName', '');
        setValue('goalID', '');
        setValue('existingGoalID', '');
        setGoalNameOptions([]);
        setParentTaskOptions([]);
        setValue('startGoalDate', null);
        setValue('endGoalDate', null);
        setValue('goalType', '');
        setTaskTypeOptions([]);
        setTaskChecklist([]);
        setClearSelected(true);
        setClearGoalSelected(true)
        setGoalState("new")
        setMemberTasks({});
        setExpandedMembers({});

        // Clear attachments, links and skills when project changes
        setImgUrls([]);
        setFileNames([]);
        setFileTypes([]);
        setExistingAttachments([]);
        setLinks([]);
        setSelectedSkills([]);
        setValidationMessage(null);
    }

    async function handleGoalType(key: any, name: string): Promise<void> {
        setClearGoalSelected(false);
        setValue('goalID', key)
        setValue('goalType', name)
        trigger('goalType')

        await getExistingGoals({
            variables: {
                static_goal_id: parseInt(key),
                project_id: parseInt(getValues('projectID'))
            },
        }).then((res) => {
            if (res.data.goals_by_static_goal_id[0] && res.data.goals_by_static_goal_id[0].status_code === 200) {
                const goals = res.data.goals_by_static_goal_id[0].goals.map((goal: any) => ({
                    key: goal.id,
                    name: goal.title
                }));
                setGoalNameOptions(goals);
            } else {
                setGoalNameOptions([]);
            }
        }).catch((err) => {
            if (err instanceof ApolloError) {
                showError(err.message);
            }
        })
    }

    function handleGoalName(key: any, name: string): void {
        setValue('existingGoalID', key)
        setValue('goalName', name)
        trigger('goalName')

        // Clear previous attachments, links and skills when selecting a different existing goal
        setImgUrls([]);
        setFileNames([]);
        setFileTypes([]);
        setExistingAttachments([]);
        setLinks([]);
        setSelectedSkills([]);
        setValidationMessage(null);

        if (existingGoalsData && existingGoalsData.goals_by_static_goal_id[0]?.goals.length > 0) {
            const goal = existingGoalsData.goals_by_static_goal_id[0].goals.find((g: any) => g.id == key);
            const goalTasks = goal?.tasks?.map((t: any) => ({
                key: t.id,
                name: t.title
            }));
            setParentTaskOptions(goalTasks);
            setValue('startGoalDate', goal.start_date.split("T")[0]);
            setValue('endGoalDate', goal.end_date.split("T")[0]);
            setValue('goalDescription', goal.description || '');

            const memberOptions = goal?.goal_members?.map((gm: any) => ({
                key: gm.employee_id,
                name: gm.employee_name
            }));
            setSelectedMembers(memberOptions);
            setOriginalMembers(memberOptions || []); // Store original members

            // Get detailed goal data for existing goal functionality
            getGoalDetails({
                variables: {
                    goal_id: parseInt(key)
                }
            });
        }
    }

    const getTaskChecklistForTask = (taskTypeId: string) => {
        if (!watchGoalType || !taskTypeId) return [];

        const selectedGoal = goalsData?.goal_master_data?.goals_static?.find((goal: any) => goal.name === watchGoalType);
        const selectedTask = selectedGoal?.tasks?.find((task: any) => task.id == taskTypeId);

        if (selectedTask) {
            return selectedTask.checklists.map((item: any) => ({
                key: parseInt(item.id),
                name: item.name
            }));
        }
        return [];
    };

    const handleKeyDown = (event: any) => {
        const { key } = event;
        // Allow control keys like backspace, delete, arrows, etc.
        if (
            key === "Backspace" ||
            key === "Delete" ||
            key === "ArrowLeft" ||
            key === "ArrowRight" ||
            key === "Tab" ||
            key === "Enter"
        ) {
            return;
        }

        // Prevent non-numeric keys
        if (!/^[0-9]$/.test(key)) {
            event.preventDefault();
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        const paste = event.clipboardData.getData("text");
        if (!/^\d+$/.test(paste)) {
            event.preventDefault();
        }
    };

    // File upload functions
    function handleIconClick() {
        fileInputRef.current?.click();
    }

    async function handleFileUpload(event: ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const token = localStorage.getItem("authToken")!;
        const validTypes = ["image/jpeg", "image/png"];
        const newUrls: string[] = [];
        const newNames: string[] = [];
        const newTypes: string[] = [];

        setIsUploading(true);
        setValidationMessage(null);

        for (const file of Array.from(files)) {
            // if (!validTypes.includes(file.type)) {
            //     setValidationMessage("Only JPG and PNG files are allowed.");
            //     setIsUploading(false);
            //     return;
            // }

            try {
                const url = await uploadFileDirectly(file, file.name, token);
                newUrls.push(url);
                newNames.push(file.name);
                newTypes.push(file.type)
            } catch (err) {
                console.error("Upload failed", err);
            }
        }

        setImgUrls((prev) => [...prev, ...newUrls]);
        setFileNames((prev) => [...prev, ...newNames]);
        setFileTypes((prev) => [...prev, ...newTypes]);
        setIsUploading(false);
    }

    // Skills handler functions
    const handleSelectSkills = (key: any, name: any, type: any) => {
        const allOptions = skillOptions;

        if (key === "all") {
            if (name === true) {
                // Deselect all
                setSelectedSkills([]);
            } else {
                // Select all
                setSelectedSkills(allOptions);
            }
        } else {
            setSelectedSkills((prev) => {
                const exists = prev.some((item) => item.key == key);
                if (exists) {
                    // REMOVE if already selected
                    return prev.filter((item) => item.key != key);
                } else {
                    // ADD if not selected
                    return [...prev, { key, name, type }];
                }
            });
        }
    };

    const handleRemoveSkill = (key: string) => {
        // Check if this skill is used in any NEW task (added via form/popup)
        const isSkillUsedInNewTasks = Object.values(memberTasks).some(tasks =>
            tasks.some(task => task.taskSkillID === key)
        );

        // Check if this skill is used in any EXISTING task (from API) - only for existing goals
        let isSkillUsedInExistingTasks = false;
        if (watchGoal === "existing" && existingGoalData?.tasks) {
            isSkillUsedInExistingTasks = existingGoalData.tasks.some((task: any) => {
                return task.skills?.some((skill: any) => skill.skill_id == key);
            });
        }

        if (isSkillUsedInNewTasks || isSkillUsedInExistingTasks) {
            showError('This skill is being used in one or more tasks. Please remove it from tasks first.');
            return;
        }

        setSelectedSkills((prev) => prev.filter((item) => item.key !== key));
    };

    // Task skill handler function (single selection)
    const handleSelectTaskSkill = (memberKey: string, taskId: string, key: any, name: any) => {
        setMemberTasks(prev => ({
            ...prev,
            [memberKey]: prev[memberKey].map(task =>
                task.id === taskId
                    ? { ...task, taskSkill: name, taskSkillID: key.toString() }
                    : task
            )
        }));
    };

    const handleRemoveMember = (key: string) => {
        if (watchGoal === "existing") {
            // For existing goals, use EditGoal-like logic
            if (!isRemovableMember(key)) {
                showError('Cannot remove original goal members');
                return;
            }

            // Check if this member has any reassigned tasks
            const hasReassignedTasks = Object.values(taskReplacements).includes(key);
            if (hasReassignedTasks) {
                const reassignedTaskCount = Object.values(taskReplacements).filter(assigneeId => assigneeId === key).length;
                const memberName = selectedMembers.find(m => m.key === key)?.name || 'Unknown Member';

                // Show NotifyPopup for confirmation
                setMemberToRemove({
                    key,
                    name: memberName,
                    reassignedTaskCount
                });
                setShowRemoveConfirmation(true);
                return;
            }

            // If no reassigned tasks, remove directly
            performMemberRemoval(key);
        } else {
            // For new goals, use original logic
            setSelectedMembers((prev) => prev.filter((item) => item.key !== key));
        }
    };

    const performMemberRemoval = (key: string) => {
        setSelectedMembers((prev) => prev.filter((item) => item.key !== key));
        // Also remove tasks for this member
        setMemberTasks((prev) => {
            const newTasks = { ...prev };
            delete newTasks[key];
            return newTasks;
        });
    };

    const handleConfirmRemoveMember = () => {
        if (!memberToRemove) return;

        // Revert task assignments for this member
        const updatedReplacements = { ...taskReplacements };
        Object.keys(updatedReplacements).forEach(taskId => {
            if (updatedReplacements[taskId] === memberToRemove.key) {
                delete updatedReplacements[taskId];
            }
        });
        setTaskReplacements(updatedReplacements);

        // Remove the member
        performMemberRemoval(memberToRemove.key);

        // Show success message
        showSuccess(`Task assignments reverted and ${memberToRemove.name} removed`);

        // Close popup
        setShowRemoveConfirmation(false);
        setMemberToRemove(null);
    };

    const handleCancelRemoveMember = () => {
        setShowRemoveConfirmation(false);
        setMemberToRemove(null);
    };

    const handleAddMember = (memberData: any) => {
        if (editingMember) {
            // If editing and member changed, handle the reassignment
            if (editingMember.key !== memberData.member.key) {
                // Remove tasks from old member
                setMemberTasks((prev) => {
                    const newTasks = { ...prev };
                    delete newTasks[editingMember.key];
                    return newTasks;
                });

                // Remove old member from selectedMembers if they were newly added (not original)
                if (isRemovableMember(editingMember.key)) {
                    setSelectedMembers((prev) => prev.filter((member) => member.key !== editingMember.key));
                }

                // Add new member to selectedMembers if not already there
                setSelectedMembers((prev) => {
                    const exists = prev.some((member) => member.key === memberData.member.key);
                    if (!exists) {
                        return [...prev, memberData.member];
                    }
                    return prev;
                });
            }

            // Always update tasks for the selected member (new or same)
            setMemberTasks((prev) => ({
                ...prev,
                [memberData.member.key]: memberData.tasks
            }));
        } else {
            // Adding member or adding tasks to existing member
            setSelectedMembers((prev) => {
                const exists = prev.some((member) => member.key === memberData.member.key);
                if (!exists) {
                    // Add new member to selectedMembers
                    return [...prev, memberData.member];
                }
                // Member already exists, just return the current list
                return prev;
            });

            // Always update/add tasks for the member
            setMemberTasks((prev) => ({
                ...prev,
                [memberData.member.key]: memberData.tasks
            }));
        }

        setShowAddMemberPopup(false);
        setEditingMember(null);
    };

    const handleMemberClick = (member: any) => {
        // Check if this member has tasks
        const memberTaskList = memberTasks[member.key] || [];
        if (memberTaskList.length > 0) {
            setEditingMember(member);
            setShowAddMemberPopup(true);
        }
    };

    const getAvailableMembers = () => {
        // For existing goals, return ALL project members (including existing goal members)
        // so users can add tasks to existing members as well
        if (watchGoal === "existing") {
            return assignedMemberOptions || [];
        }

        // For new goals, keep the original filtering logic (exclude already selected members)
        if (!assignedMemberOptions || !selectedMembers) return [];
        return assignedMemberOptions.filter(member =>
            !selectedMembers.some(selected => selected.key === member.key)
        );
    };

    const isRemovableMember = (memberKey: string) => {
        // A member is removable if they are NOT in the original members list
        return !originalMembers.some(original => original.key === memberKey);
    };

    const handleReplaceMember = (member: any) => {
        setMemberToReplace(member);
        setShowReplaceMemberPopup(true);
    };

    const handleReplaceMemberSubmit = (data: {
        originalMember: { key: string; name: string };
        replacementMember: { key: string; name: string };
        selectedTasks: string[];
    }) => {
        // Update local state to track task replacements
        const newReplacements = { ...taskReplacements };
        data.selectedTasks.forEach(taskId => {
            newReplacements[taskId] = data.replacementMember.key;
        });
        setTaskReplacements(newReplacements);

        // Add replacement member to selectedMembers if not already there
        setSelectedMembers(prev => {
            const exists = prev.some(member => member.key === data.replacementMember.key);
            if (!exists) {
                return [...prev, data.replacementMember];
            }
            return prev;
        });

        showSuccess(`${data.selectedTasks.length} task(s) will be reassigned from ${data.originalMember.name} to ${data.replacementMember.name} when you save`);

        // Close the popup
        setShowReplaceMemberPopup(false);
        setMemberToReplace(null);
    };

    // Get member tasks with status from actual API data (for existing goals)
    const getMemberTasksWithStatus = (memberKey: string) => {
        if (!existingGoalData?.tasks) {
            return [];
        }

        const tasks = existingGoalData.tasks;

        // Filter tasks assigned to the specific member (considering replacements)
        const memberTasks = tasks.filter((task: any) => {
            const taskId = task.id?.toString();
            // Check if task has been reassigned locally
            if (taskReplacements[taskId]) {
                return taskReplacements[taskId] === memberKey;
            }
            // Otherwise use original assignment
            return task.assigned_to_id == memberKey;
        });

        // Map to the format expected by ReplaceMemberPopup
        return memberTasks.map((task: any) => {
            const taskId = task.id?.toString();
            const isReassigned = taskReplacements[taskId];

            return {
                id: taskId || '',
                taskName: task.title || 'Untitled Task',
                taskDescription: task.static_task_type_name || '',
                status: task.status_name,
                taskType: task.static_task_type_name,
                startDate: task.start_datetime,
                endDate: task.end_datetime,
                priority: task.priority,
                assignedToName: isReassigned ?
                    selectedMembers.find(m => m.key === isReassigned)?.name || task.assigned_to_name :
                    task.assigned_to_name,
                isReassigned: !!isReassigned
            };
        });
    };

    const validateMemberTasks = (): boolean => {
        if (selectedMembers.length === 0) {
            showError('Please select at least one Goal member');
            return false;
        }

        for (const member of selectedMembers) {
            const tasks = memberTasks[member.key] || [];

            if (tasks.length === 0) {
                showError(`Please add at least one task for ${member.name}`);
                return false;
            }

            for (const task of tasks) {
                if (!task.taskType) {
                    showError(`Please select task type for ${member.name}'s task`);
                    return false;
                }

                if (!task.taskName || task.taskName.trim() === '') {
                    showError(`Please enter task name for ${member.name}'s task`);
                    return false;
                }

                if (!task.startTaskDate) {
                    showError(`Please select start date for ${member.name}'s task`);
                    return false;
                }

                if (task.taskChecklist.length === 0) {
                    showError(`Please select at least one checklist item for ${member.name}'s task`);
                    return false;
                }

                if (!task.taskSkillID) {
                    showError(`Please select a skill for ${member.name}'s task`);
                    return false;
                }

                const totalDurationMinutes = (task.durationTimeHour * 60) + task.durationTimeMinute;
                if (totalDurationMinutes < 15 && task.taskType !== "Meeting / Knowledge Transfer") {
                    showError(`Total duration must be at least 15 minutes for ${member.name}'s task`);
                    return false;
                }
            }
        }
        return true;
    };

    async function onSubmit(data: any): Promise<void> {
        // Validate skills
        if (selectedSkills?.length < 1) {
            showError('Please select at least one goal skill');
            return;
        }

        if (watchGoal === "new") {
            // Validate member tasks for new goals
            if (!validateMemberTasks()) {
                return;
            }
        } else {
            // For existing goals, validate member tasks similar to EditGoal
            if (selectedMembers.length === 0) {
                showError('Please select at least one Goal member');
                return;
            }

            // Only include members who have tasks (same logic as UI filtering)
            const membersWithTasks = selectedMembers.filter((member: any) => {
                // Check for existing/reassigned tasks
                const memberTaskList = getMemberTasksWithStatus(member.key);
                // Check for new tasks added via popup
                const newTasks = memberTasks[member.key] || [];
                // Include member if they have either type of tasks
                return memberTaskList.length > 0 || newTasks.length > 0;
            });

            if (membersWithTasks.length === 0) {
                showError('Please assign tasks to at least one member before saving');
                return;
            }
        }

        // Only include members who have tasks (same logic as UI filtering)
        const membersWithTasks = selectedMembers.filter((member: any) => {
            if (watchGoal === "new") {
                // For new goals, check if member has tasks in memberTasks
                const tasks = memberTasks[member.key] || [];
                return tasks.length > 0;
            } else {
                // For existing goals, check for existing/reassigned tasks OR new tasks
                const memberTaskList = getMemberTasksWithStatus(member.key);
                const newTasks = memberTasks[member.key] || [];
                return memberTaskList.length > 0 || newTasks.length > 0;
            }
        });

        const keys = membersWithTasks.map((member: any) => parseInt(member.key));

        // if (keys.length < 2) {
        //     showError('Please assign tasks to at least two members before saving');
        //     return
        // }

        // Prepare tasks array
        const allTasks = [];

        if (watchGoal === "new") {
            // Handle multiple member tasks for new goals
            for (const member of membersWithTasks) {
                const tasks = memberTasks[member.key] || [];
                for (const task of tasks) {
                    const checklists = task.taskChecklist.map((checklist_id: string) => ({
                        task_id: parseInt(task.taskID),
                        checklist_id: parseInt(checklist_id),
                        status: false,
                        created_by: parseInt(employeeID),
                    }));

                    const parsedDate = task.endDate && parse(task.endDate, 'MM-dd-yyyy', new Date());
                    const ed = parsedDate && format(parsedDate, "yyyy-MM-dd");

                    const taskSkillIds = task.taskSkillID ? [parseInt(task.taskSkillID)] : [];

                    allTasks.push({
                        is_new_task: true,
                        goal_id: data.existingGoalID ? parseInt(data.existingGoalID) : 1,
                        static_goal_id: parseInt(data.goalID),
                        static_task_id: parseInt(task.taskID),
                        task_title: task.taskName,
                        task_start_date: task.startTaskDate ? `${task.startTaskDate}T00:00:00.000Z` : null,
                        task_end_date: ed ? `${ed}T23:59:59.000Z` : null,
                        dependency_task: task.parentTaskID ? parseInt(task.parentTaskID) : null,
                        created_by: parseInt(employeeID),
                        days: task.durationDays,
                        hours: task.durationTimeHour,
                        mins: task.durationTimeMinute,
                        checklists: checklists,
                        assigned_to: parseInt(member.key),
                        skill_ids: taskSkillIds,
                    });
                }
            }
        } else {
            // Handle existing goals - similar to EditGoal logic

            // First, handle task replacements (existing tasks with new assignments)
            const replacementTasks = [];
            for (const [taskId, newAssigneeId] of Object.entries(taskReplacements)) {
                // Find the original task data from existingGoalData
                const originalTask = existingGoalData?.tasks?.find((task: any) =>
                    task.id?.toString() === taskId
                );

                if (originalTask) {
                    // Get existing checklists for this task
                    const existingChecklists = originalTask.checklist_items?.map((item: any) => ({
                        task_id: parseInt(taskId),
                        checklist_id: parseInt(item.checklist?.id || item.id),
                        status: item.status || false,
                        created_by: parseInt(employeeID),
                    })) || [];

                    // Parse end date if exists
                    let endDate = null;
                    if (originalTask.end_datetime) {
                        const date = new Date(originalTask.end_datetime);
                        endDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T23:59:59.000Z`;
                    }

                    // Parse start date if exists
                    let startDate = null;
                    if (originalTask.start_datetime) {
                        const date = new Date(originalTask.start_datetime);
                        startDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00.000Z`;
                    }

                    replacementTasks.push({
                        is_new_task: false,
                        existing_task_id: parseInt(taskId),
                        goal_id: parseInt(data.existingGoalID),
                        static_goal_id: parseInt(data.goalID),
                        static_task_id: parseInt(originalTask.tasks_static_id),
                        task_title: originalTask.title,
                        task_start_date: startDate,
                        task_end_date: endDate,
                        dependency_task: originalTask.dependency_task_id ? parseInt(originalTask.dependency_task_id) : null,
                        created_by: parseInt(employeeID),
                        days: originalTask.days || 1,
                        hours: originalTask.hours || 0,
                        mins: originalTask.mins || 0,
                        checklists: existingChecklists,
                        assigned_to: parseInt(newAssigneeId),
                    });
                } else {
                    console.warn(`Original task with ID ${taskId} not found for replacement`);
                }
            }

            // Then, handle new tasks from memberTasks
            for (const memberKey of membersWithTasks.map(m => m.key)) {
                const tasks = memberTasks[memberKey] || [];
                for (const task of tasks) {
                    const checklists = task.taskChecklist.map((checklist_id: string) => ({
                        task_id: parseInt(task.taskID),
                        checklist_id: parseInt(checklist_id),
                        status: false,
                        created_by: parseInt(employeeID),
                    }));

                    // Parse date from MM-dd-yyyy format to yyyy-MM-dd
                    let ed = null;
                    if (task.endDate) {
                        const [month, day, year] = task.endDate.split('-');
                        ed = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    }

                    const taskSkillIds = task.taskSkillID ? [parseInt(task.taskSkillID)] : [];

                    allTasks.push({
                        is_new_task: true,
                        goal_id: parseInt(data.existingGoalID),
                        static_goal_id: parseInt(data.goalID),
                        static_task_id: parseInt(task.taskID),
                        task_title: task.taskName,
                        task_start_date: task.startTaskDate ? `${task.startTaskDate}T00:00:00.000Z` : null,
                        task_end_date: ed ? `${ed}T23:59:59.000Z` : null,
                        dependency_task: task.parentTaskID ? parseInt(task.parentTaskID) : null,
                        created_by: parseInt(employeeID),
                        days: task.durationDays,
                        hours: task.durationTimeHour,
                        mins: task.durationTimeMinute,
                        checklists: checklists,
                        assigned_to: parseInt(memberKey),
                        skill_ids: taskSkillIds,
                    });
                }
            }

            // Combine new tasks and replacement tasks
            allTasks.push(...replacementTasks);
        }

        // Compute removed members (original members not in current goal_members)
        const removedMembers = originalMembers
            .filter((member: any) => !keys.includes(member.key))
            .map((member: any) => member.key);

        // Prepare attachments - for existing goals, only send new attachments
        let attachmentList = [];
        if (watchGoal === "existing") {
            // For existing goals, filter out existing attachments and only send new ones
            const existingUrls = new Set(existingAttachments.map((att) => att.file_path));
            attachmentList = imgUrls
                ?.map((url, index) => ({
                    file_name: fileNames[index],
                    file_path: url,
                    file_type: fileTypes[index]
                }))
                .filter((item) => !existingUrls.has(item.file_path)) || [];
        } else {
            // For new goals, send all attachments
            attachmentList = imgUrls?.map((url, index) => ({
                file_name: fileNames[index],
                file_path: url,
                file_type: fileTypes[index]
            })) || [];
        }

        // Prepare links - send all links (API should handle existing vs new)
        const urls = links.map(l => l.url);

        // Prepare skills
        const skillIds = selectedSkills?.length > 0 ? selectedSkills?.map((s: any) => {
            return parseInt(s?.key)
        }) : [];

        const goalData = {
            goal_title: data.goalName,
            project_id: parseInt(data.projectID),
            static_goal_id: parseInt(data.goalID),
            is_new_goal: data?.goal === "new" ? true : false,
            goal_start_date: `${data.startGoalDate}T00:00:00.000Z`,
            goal_end_date: `${data.endGoalDate}T23:59:59.000Z`,
            created_by: parseInt(employeeID),
            existing_goal_id: data.existingGoalID ? parseInt(data.existingGoalID) : null,
            description: data.goalDescription || null,
            goal_members: keys,
            removed_member_ids: removedMembers,
            idea_box_goal_id: state?.ideaID ? parseInt(state.ideaID) : null,
            tasks: allTasks,
            attachment_list: attachmentList,
            links: urls,
            skill_ids: skillIds,
            pod_id:parseInt(selectedPodId)
        }

        try {
            const response = await createGoal({ variables: { goal_data: goalData } });
            if (response.data.create_goal.status_code === 200) {
                  const patchData = {
                    is_goal_exist:true,
                    goal_id:Number(response.data.create_goal?.goal?.id),
                    action_type:state.action,
                    project_name:data?.projectName
                }
                 if (state?.action == "Bug") {
                    setLoading(true)
                    await fetch('https://api.wizkind.com/wizkind-mobile-ai/wizkind-bug-agent', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        defect_id: state?.defectID,
                    })
                    })
                     setLoading(false)
                }
                  if (state.action === 'Unclear') {
                      setLoading(true)
                    await fetch('https://api.wizkind.com/wizkind-mobile-ai/wizkind-unclear-agent', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                                    defect_id: state?.defectID,
                    })
                    })
                            setLoading(false)
                }
                await patchDefect({ variables: { id:  state?.defectID, input: patchData } });
                showSuccess(response.data.create_goal.message)
                navigate('/dashboard')
            }
            if (response.data.create_goal.status_code === 400) {
                showError(response.data.create_goal.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    function onError(errors: any) {
        // For new goals, validate member tasks when form has errors
        if (watchGoal === "new" && !validateMemberTasks()) {
            return;
        }

        // Show first form validation error
        const firstError = Object.keys(errors)[0];
        if (firstError && errors[firstError]?.message) {
            showError(errors[firstError].message);
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)} id="cts-respon-p-dv" className="w-full  relative  overflow-hidden flex flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4  box-border text-left text-base text-gray font-manrope">
                <div className="flex-1 flex flex-col items-start justify-start gap-6">
                    <BreadCumb />
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Add Task</h3>
                    </div>

                    {/* Goal Type Selection - Moved to top */}
                    <div className="self-stretch rounded-lg bg-surface-bg-primary flex flex-col items-start justify-start gap-4 p-8 mq575:p-3">
                        <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">Goal Type Selection</h5>
                        <div className="self-stretch flex flex-col items-start justify-start gap-[16px]">
                            <div className="grid grid-cols-4 mq575:grid-cols-1 gap-[16px] min-w-full">
                                <div className="flex flex-row items-center justify-start gap-[6px]">
                                    <input
                                        className="cursor-pointer m-0 h-4 w-4 relative overflow-hidden shrink-0"
                                        type="radio"
                                        value="new"
                                        {...register('goal')}
                                        onClick={() => {
                                            setValue('goalName', '');
                                            setValue('goalID', '');
                                            setValue('existingGoalID', '');
                                            setGoalNameOptions([]);
                                            setParentTaskOptions([]);
                                            setValue('startGoalDate', null);
                                            setValue('endGoalDate', null);
                                            setValue('goalType', '');
                                            setTaskTypeOptions([]);
                                            setTaskChecklist([]);
                                            setClearSelected(true);
                                            setClearGoalSelected(true)
                                            setGoalState("new")
                                            // Clear goal members and reset member tasks
                                            setSelectedMembers([]);
                                            setMemberTasks({});
                                            setExpandedMembers({});

                                            // Clear existing goal specific state
                                            setOriginalMembers([]);
                                            setTaskReplacements({});
                                            setExistingGoalData(null);

                                            // Clear attachments, links and skills
                                            setImgUrls([]);
                                            setFileNames([]);
                                            setFileTypes([]);
                                            setExistingAttachments([]);
                                            setLinks([]);
                                            setSelectedSkills([]);
                                            setValidationMessage(null);
                                        }}
                                        id="newGoal"
                                    />
                                    <label htmlFor="newGoal" className={`cursor-pointer relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block min-w-[50px] ${watchGoal === 'new' ? 'text-main-blue font-bold' : ''}`}>
                                        New Goal
                                    </label>
                                </div>
                                <div className="flex flex-row items-center justify-start gap-[6px]">
                                    <input
                                        className="cursor-pointer m-0 h-4 w-4 relative overflow-hidden shrink-0"
                                        type="radio"
                                        value="existing"
                                        {...register('goal')}
                                        onClick={() => {
                                            setValue('goalName', '');
                                            setValue('goalID', '');
                                            setValue('existingGoalID', '');
                                            setGoalNameOptions([]);
                                            setParentTaskOptions([]);
                                            setValue('startGoalDate', null);
                                            setValue('endGoalDate', null);
                                            setValue('goalType', '');
                                            setTaskTypeOptions([]);
                                            setTaskChecklist([]);
                                            setClearSelected(true);
                                            setClearGoalSelected(true)
                                            setGoalState("existing")
                                            // Clear goal members and reset member tasks
                                            setSelectedMembers([]);
                                            setMemberTasks({});
                                            setExpandedMembers({});

                                            // Clear existing goal specific state
                                            setOriginalMembers([]);
                                            setTaskReplacements({});
                                            setExistingGoalData(null);

                                            // Clear attachments, links and skills
                                            setImgUrls([]);
                                            setFileNames([]);
                                            setFileTypes([]);
                                            setExistingAttachments([]);
                                            setLinks([]);
                                            setSelectedSkills([]);
                                            setValidationMessage(null);
                                        }}
                                        id="existingGoal"
                                    />
                                    <label htmlFor="existingGoal" className={`cursor-pointer relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block min-w-[50px] ${watchGoal === 'existing' ? 'text-main-blue font-bold' : ''}`}>
                                        Existing Goal
                                    </label>
                                </div>
                            </div>
                            {errors?.goal && (
                                <p className="text-red p-2 cts-bg-error my-0 flex items-center gap-[4px] ctcerror-width-blg">
                                    <img src={alertIcon} alt="" />
                                    {typeof errors.goal.message === 'string' ? errors.goal.message : 'Invalid input'}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        <h5 className="my-0 text-xl-dv self-stretch relative text-lg">Goal Details</h5>
                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1  gap-[8px] min-w-full">
                            <SearchableInputsDropdown
                                label="Project Name*"
                                initialValue={watchProjectName}
                                placeHolder="Select Project"
                                options={projectOptions}
                                onSelect={handleSelectProject}
                                errorMessage={errors?.projectName}
                            />
                            <div className="flex flex-col items-start justify-start box-border gap-[16px] col-span-3">
                                <label className="cursor-pointer self-stretch h-[25px] relative font-semibold inline-block shrink-0">Goal For*</label>
                                <div className="self-stretch flex flex-row items-center justify-start py-0 pl-0 gap-[16px] mq1275:gap-[5px] mq950:gap-[16px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border">
                                    <div className="flex flex-row items-center justify-start gap-[6px]">
                                        <input
                                            className="cursor-pointer m-0 h-4 w-4 relative overflow-hidden shrink-0"
                                            type="radio"
                                            value="Customer Success"
                                            {...register('goalFor')}
                                            id="cs"
                                        />
                                        <label htmlFor="cs" className={`relative inline-block  cursor-pointer`}>
                                            Customer Success
                                        </label>
                                    </div>
                                    <div className="flex flex-row items-center justify-start gap-[6px] ">
                                        <input
                                            className="cursor-pointer m-0 h-4 w-4 relative overflow-hidden shrink-0"
                                            type="radio"
                                            value="Marketing"
                                            {...register('goalFor')}
                                            id="marketing"
                                        />
                                        <label htmlFor="marketing" className={`relative inline-block  cursor-pointer`}>
                                            Marketing
                                        </label>
                                    </div>
                                    <div className=" flex flex-row items-center justify-start gap-[6px] ">
                                        <input
                                            className="cursor-pointer m-0 h-4 w-4 relative overflow-hidden shrink-0"
                                            type="radio"
                                            value="Product Development"
                                            {...register('goalFor')}
                                            id="pd"
                                        />
                                        <label htmlFor="pd" className={`relative inline-block cursor-pointer`}>
                                            Product Development
                                        </label>
                                    </div>
                                </div>
                                {errors?.goalFor && (
                                    <p className="text-red p-2 cts-bg-error my-0 flex items-center gap-[4px] ctcerror-width-blg">
                                        <img src={alertIcon} alt="" />
                                        {typeof errors.goalFor.message === 'string' ? errors.goalFor.message : 'Invalid input'}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">
                            <InputsDropdownMultipleSearchSelect
                                label="Goal Type*"
                                initialValue={watchGoalType}
                                placeHolder="Select Goal Type"
                                options={goalTypeOptions}
                                onSelect={handleGoalType}
                                inputType="radio"
                                errorMessage={errors?.goalType}
                                clearSelected={clearGoalSelected}
                            />
                            {watchGoal === "existing" && (
                                <SearchableInputsDropdown
                                    label="Goal Name/Label*"
                                    initialValue={watchGoalName}
                                    placeHolder="Select Goal Name"
                                    options={goalNameOptions}
                                    onSelect={handleGoalName}
                                    errorMessage={errors?.goalName}
                                    clearSelected={clearGoalSelected}
                                />
                            )}
                            {watchGoal === "new" && (
                                <InputsNew
                                    contentPlaceholder="Goal Label/Name*"
                                    label="Goal Name"
                                    type="text"
                                    register={register('goalName')}
                                    errorMessage={errors.goalName}
                                />
                            )}
                            <div className="flex flex-col items-start justify-start gap-[8px] startdate-inner-input">
                                <Controller
                                    name="startGoalDate"
                                    control={control}
                                    render={({ field }) => (
                                        <DateSelector
                                            label="Start Date*"
                                            selectedDate={field.value}
                                            onChange={(date: string | null) => {
                                                const endDate = watch('endGoalDate');

                                                if (endDate && date) {
                                                    const end = new Date(endDate);
                                                    const start = new Date(date);

                                                    if (start > end) {
                                                        showError('End date cannot be earlier than start date.');
                                                        trigger('endGoalDate');
                                                        return;
                                                    }

                                                    const diffDays = differenceInDays(end, start);
                                                    if (diffDays > 15) {
                                                        showError('End date cannot be more than 15 days after the start date.');
                                                        // setValue('endGoalDate', null)
                                                        trigger('endGoalDate');
                                                        return;
                                                    }
                                                }

                                                // if (endDate && date && new Date(date) > new Date(endDate)) {
                                                //     showError('End date cannot be earlier than start date.');
                                                //     trigger('startGoalDate');
                                                //     return;
                                                // }

                                                field.onChange(date);
                                                setValue('startGoalDate', date);
                                                trigger('startGoalDate');

                                                // Clear all task start dates when goal start date changes
                                                const updatedMemberTasks: MemberTasks = {};
                                                Object.keys(memberTasks).forEach(memberKey => {
                                                    updatedMemberTasks[memberKey] = memberTasks[memberKey].map(task => ({
                                                        ...task,
                                                        startTaskDate: null,
                                                        endDate: null
                                                    }));
                                                });
                                                setMemberTasks(updatedMemberTasks);
                                            }}
                                            error={errors.startGoalDate?.message}
                                            nothideParsedValue={true}
                                            disabled={watchGoal === "existing"}
                                        />
                                    )}
                                />
                            </div>

                            <div className="flex flex-col items-start justify-start gap-[8px] startdate-inner-input">
                                <Controller
                                    name="endGoalDate"
                                    control={control}
                                    render={({ field }) => (
                                        <DateSelector
                                            label="End Date*"
                                            selectedDate={field.value}
                                            onChange={(date: string | null) => {
                                                const startDate = watch('startGoalDate');

                                                if (startDate && date) {
                                                    const start = new Date(startDate);
                                                    const end = new Date(date);

                                                    if (end < start) {
                                                        showError('End date cannot be earlier than start date.');
                                                        trigger('endGoalDate');
                                                        return;
                                                    }

                                                    const diffDays = differenceInDays(end, start);
                                                    if (diffDays > 15) {
                                                        showError('End date cannot be more than 15 days after the start date.');
                                                        trigger('endGoalDate');
                                                        return;
                                                    }
                                                }

                                                // if (startDate && date && new Date(date) < new Date(startDate)) {
                                                //     showError('End date cannot be earlier than start date.');
                                                //     trigger('endGoalDate');
                                                //     return;
                                                // }

                                                field.onChange(date);
                                                setValue('endGoalDate', date);
                                                trigger('endGoalDate');

                                                // Clear all task start dates when goal end date changes
                                                const updatedMemberTasks: MemberTasks = {};
                                                Object.keys(memberTasks).forEach(memberKey => {
                                                    updatedMemberTasks[memberKey] = memberTasks[memberKey].map(task => ({
                                                        ...task,
                                                        startTaskDate: null,
                                                        endDate: null
                                                    }));
                                                });
                                                setMemberTasks(updatedMemberTasks);
                                            }}
                                            error={errors.endGoalDate?.message}
                                            nothideParsedValue={true}
                                            disabled={watchGoal === "existing"}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        {/* Pod Selection — above Goal Members for both flows */}
                        <div className="grid grid-cols-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[8px] min-w-full mt-[8px]">
                            <SearchableInputsDropdown
                                label="Pod"
                                initialValue={selectedPodName}
                                placeHolder={podsLoading ? 'Loading pods…' : 'Select a pod to auto-fill members'}
                                options={podOptions}
                                onSelect={handlePodSelect}
                                showSearchable={true}
                            />
                        </div>

                        {/* Goal Members Section - Different UI for New vs Existing Goals */}
                        {watchGoal === "new" ? (
                            // New Goal - Updated member selection UI with availability
                            <div className="grid grid-cols-3 mq1400:grid-3 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 mt-[8px] gap-[8px] min-w-full">
                                <div className="items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg addtsk_goal-dv">
                                    {resourceOverviewLoading ? (
                                        <div className="flex flex-col gap-2">
                                            <label className="font-semibold pb-2 dark:text-white">Goal Members*</label>
                                            <div className="flex items-center justify-center p-4 border border-gray-300 rounded-md bg-gray-50 dark:bg-gray-800 dark:border-gray-600">
                                                <div className="flex items-center gap-2">
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                                    <span className="text-sm text-gray-600 dark:text-gray-400">Loading member availability...</span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="memberavailability-input_main">
                                            <MemberAvailabilityDropdown
                                                label="Goal Members*"
                                                placeHolder={assignedMemberOptions.length === 0 ? "Please select goal dates first" : "Choose"}
                                                options={assignedMemberOptions}
                                                onSelect={handleSelectMembers}
                                                inputType="checkbox"
                                                checkedItems={selectedMembers}
                                                clearSelected={clearMemberSelected}
                                                disableDropdown={assignedMemberOptions.length === 0}
                                            />
                                            {assignedMemberOptions.length > 0 && (
                                                <div className="mt-2 text-xs text-gray-600 dark:text-gray-400">
                                                    {(() => {
                                                        const availableCount = assignedMemberOptions.filter(m => m.isAvailable).length;
                                                        const totalCount = assignedMemberOptions.length;
                                                        return (
                                                            <span className="" style={{ lineHeight: "23px" }}>
                                                                <span className="text-green-600 dark:text-green-400 font-semibold"><span className="member-available">{availableCount} available </span></span>
                                                                {' • '}
                                                                <span className="text-red-600 dark:text-red-400 font-semibold light-red-blg-dv">{totalCount - availableCount} not available</span>
                                                                {' of '}{totalCount} total members
                                                            </span>
                                                        );
                                                    })()}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {selectedMembers?.length > 0 && (
                                        <div className="reportmulselect-blg flex-1 w-full cts-flex1-remd contents flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full">
                                            <div className="inner-reportmulselect-blg items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg mt-2">
                                                {selectedMembers.map((it: any) => (
                                                    <div
                                                        key={it.key}
                                                        className="reportmulselect-blg-dv rounded-radius-md1 overflow-hidden flex flex-row items-center justify-start gap-[8px] inner-item-select-dv border-[1px] border-solid border-surface-border dark:bg-slate-700"
                                                    >
                                                        <div className="flex flex-row items-center justify-start gap-2">
                                                            <div className={`w-2 h-2 rounded-full ${it.isAvailable ? 'bg-green-500' : 'bg-red-500'
                                                                }`}></div>
                                                            <div className="relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block dark:text-white">
                                                                {it.name}
                                                            </div>
                                                            {it.availableHours !== undefined && (
                                                                <div className="text-xs text-gray-500 dark:text-gray-400">
                                                                    ({it.availableHours.toFixed(1)}h available)
                                                                </div>
                                                            )}
                                                        </div>
                                                        <img
                                                            className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                                            loading="lazy"
                                                            alt="Remove"
                                                            src={closeDowpDowniconimg}
                                                            onClick={() => handleRemoveMember(it.key)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            // Existing Goal - EditGoal-like member management UI
                            <div className="flex items-start justify-start gap-4 flex-col w-full">
                                <div className="flex items-center justify-between w-full">
                                    <div className="flex flex-col">
                                        <label className="text-sm font-semibold dark:text-white">Goal Members</label>
                                        <span className="text-xs text-gray-500 dark:text-gray-400">
                                            Original members cannot be removed
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setShowAddMemberPopup(true)}
                                        className="py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] addmembertask-btn text-white text-sm rounded plus-task-btn"
                                    >
                                        Add Member/Task
                                    </button>
                                </div>

                                {(() => {
                                    const membersWithTasks = selectedMembers?.filter((member: any) => {
                                        // Check for existing/reassigned tasks
                                        const memberTaskList = getMemberTasksWithStatus(member.key);
                                        // Check for new tasks added via popup
                                        const newTasks = memberTasks[member.key] || [];
                                        // For original members, show them even if task data hasn't loaded yet
                                        const isOriginalMember = originalMembers.some(original => original.key === member.key);
                                        // Show member if they have tasks OR if they are original members (even without task data loaded yet)
                                        return memberTaskList.length > 0 || newTasks.length > 0 || isOriginalMember;
                                    }) || [];
                                    return membersWithTasks.length > 0;
                                })() ? (
                                    <div className="w-full border border-gray-300 dark:border-gray-600 rounded-md py-4">
                                        <div className="grid gap-2">
                                            {selectedMembers
                                                .filter((member: any) => {
                                                    // Check for existing/reassigned tasks
                                                    const memberTaskList = getMemberTasksWithStatus(member.key);
                                                    // Check for new tasks added via popup
                                                    const newTasks = memberTasks[member.key] || [];
                                                    // For original members, show them even if task data hasn't loaded yet
                                                    const isOriginalMember = originalMembers.some(original => original.key === member.key);
                                                    // Show member if they have tasks OR if they are original members (even without task data loaded yet)
                                                    return memberTaskList.length > 0 || newTasks.length > 0 || isOriginalMember;
                                                })
                                                .map((member: any) => {
                                                    const memberTaskList = getMemberTasksWithStatus(member.key);
                                                    const newTasksList = memberTasks[member.key] || [];

                                                    // Total tasks = API tasks + new tasks
                                                    const totalTaskCount = memberTaskList.length + newTasksList.length;
                                                    const hasTasks = totalTaskCount > 0;

                                                    const isRemovable = isRemovableMember(member.key);
                                                    const isOriginalMember = !isRemovable;

                                                    // Check if member has NEW tasks (added via popup) - only these should be editable
                                                    const hasNewTasks = newTasksList.length > 0;

                                                    // Check if member has reassigned tasks
                                                    const hasReassignedTasks = memberTaskList.some((task: any) => task.isReassigned);

                                                    return (
                                                        <div
                                                            key={member.key}
                                                            className={`edittask-section flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded border ${hasNewTasks ? 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700' : ''}`}
                                                            onClick={() => hasNewTasks && handleMemberClick(member)}
                                                        >
                                                            <div className="flex items-center gap-3">
                                                                <div className={`w-8 h-8 ${hasNewTasks ? 'bg-green-500' :
                                                                    hasReassignedTasks ? 'bg-blue-500' :
                                                                        isOriginalMember ? 'bg-gray-500' : 'bg-blue-500'
                                                                    } text-white rounded-full flex items-center justify-center text-sm font-semibold relative`}>
                                                                    {member.name.charAt(0).toUpperCase()}
                                                                    {hasNewTasks && (
                                                                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-600 rounded-full flex items-center justify-center">
                                                                            <span className="text-xs text-white">✓</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="flex flex-col">
                                                                    <div className="flex items-center gap-2">
                                                                        {member.isAvailable !== undefined && (
                                                                            <div className={`w-2 h-2 rounded-full ${member.isAvailable ? 'bg-green-500' : 'bg-red-500'
                                                                                }`}></div>
                                                                        )}
                                                                        <span className="text-sm font-medium dark:text-white">
                                                                            {member.name}
                                                                        </span>
                                                                        {isOriginalMember && (
                                                                            <span className="text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 px-2 py-1 rounded">
                                                                                Original
                                                                            </span>
                                                                        )}
                                                                        {member.isAvailable !== undefined && (
                                                                            <span className={`text-xs px-2 py-1 rounded ${member.isAvailable
                                                                                ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                                                                                : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                                                                                }`}>
                                                                                {member.isAvailable ? 'Available' : 'Not Available'}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    {member.availableHours !== undefined && member.totalHours !== undefined && (
                                                                        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                                            {member.availableHours.toFixed(1)}h / {member.totalHours.toFixed(1)}h available
                                                                            {member.utilizationPercentage !== undefined && (
                                                                                <span className="ml-2">
                                                                                    ({member.utilizationPercentage.toFixed(0)}% utilized)
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {hasTasks ? (
                                                                        <span className={`text-xs ${hasNewTasks ? 'text-green-600 dark:text-green-400' : 'text-gray-600 dark:text-gray-400'}`}>
                                                                            {totalTaskCount} task{totalTaskCount !== 1 ? 's' : ''} assigned
                                                                            {hasReassignedTasks && (
                                                                                <span className="ml-1 px-1 py-0.5 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded text-xs">
                                                                                    • Reassigned
                                                                                </span>
                                                                            )}
                                                                            {hasNewTasks && <span> • Click to edit</span>}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="text-xs text-gray-500 dark:text-gray-400">
                                                                            {isOriginalMember ? 'Existing member' : 'No tasks assigned'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="flex items-center gap-2">
                                                                {/* Replace Member Button - Only show if member has replaceable tasks */}
                                                                {(() => {
                                                                    const memberTaskList = getMemberTasksWithStatus(member.key);
                                                                    const replaceableTasks = memberTaskList.filter((task: any) =>
                                                                        task.status === 'Not Started' &&
                                                                        task.taskType !== 'Meeting / Knowledge Transfer'
                                                                    );
                                                                    // const memberTasksCount = memberTaskList.length;
                                                                    return replaceableTasks.length > 0 ? (
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleReplaceMember(member);
                                                                            }}
                                                                            className="text-blue-500 hover:text-blue-700  replace-btn-dv"
                                                                            title={`Replace member (${replaceableTasks.length} replaceable task${replaceableTasks.length !== 1 ? 's' : ''})`}
                                                                        >
                                                                            <img src={rePlaceicon} className="w-5 h-5" alt="" />
                                                                        </button>
                                                                    ) : null;
                                                                })()}

                                                                {/* Remove Member Button */}
                                                                {(() => {
                                                                    const hasReassignedTasks = Object.values(taskReplacements).includes(member.key);

                                                                    if (isRemovable) {
                                                                        let tooltipText = "Remove member";
                                                                        let buttonClass = "text-red-500 hover:text-red-700 p-1";

                                                                        if (hasReassignedTasks) {
                                                                            const reassignedCount = Object.values(taskReplacements).filter(id => id === member.key).length;
                                                                            tooltipText = `Remove member (will revert ${reassignedCount} reassigned task${reassignedCount !== 1 ? 's' : ''})`;
                                                                            buttonClass = "text-orange-500 hover:text-orange-700 p-1";
                                                                        }

                                                                        return (
                                                                            <button
                                                                                type="button"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleRemoveMember(member.key);
                                                                                }}
                                                                                className="bg-crimson right_status_clockout red-right_status_clockout flex flex-row items-center justify-center py-1 px-0 rounded-radius-md  text-sm text-white border-none"
                                                                                title={tooltipText}
                                                                            >

                                                                                <img
                                                                                    className="h-4 w-4 grayscale"
                                                                                    src={closeDowpDowniconimg}
                                                                                    alt="Cannot remove"
                                                                                />
                                                                            </button>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <div className=" bg-crimson lightgray_status_btn flex flex-row items-center justify-center py-1 px-0 rounded-radius-md  text-sm text-white" title="Cannot remove original member">
                                                                                <img
                                                                                    className="h-4 w-4 grayscale"
                                                                                    src={closeDowpDowniconimg}
                                                                                    alt="Cannot remove"
                                                                                />

                                                                            </div>
                                                                        );
                                                                    }
                                                                })()}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="grid items-center justify-center text-center w-full  dark:border-gray-600 rounded-md  text-center addmember-nodeta">
                                        {goalDetailsLoading ? (
                                            <>
                                                <div className="flex items-center justify-center gap-2 mb-2">
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                                    <span className="text-sm text-gray-600 dark:text-gray-400">Loading goal details...</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <p className="text-gray-500 dark:text-gray-400 text-sm my-0 mt-2">
                                                    No members with tasks assigned to this goal
                                                </p>
                                                <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
                                                    Add members and assign tasks to see them here
                                                </p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="self-stretch flex flex-col items-start justify-start text-sm">
                            <div className="self-stretch rounded-radius-md  overflow-hidden flex flex-row items-start justify-start pt-2 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] ">
                                <InputsNew
                                    contentPlaceholder="Goal Description"
                                    label="Goal Description"
                                    type="textarea"
                                    register={register('goalDescription')}
                                    errorMessage={errors.goalDescription}
                                />
                            </div>
                        </div>

                        {/* Skills Section */}
                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-[8px] min-w-full reportmulselect-dropdown">
                            <div className="grid">
                                <InputsDropdownMultipleSearchSelect
                                    label="Skills"
                                    placeHolder="Choose"
                                    options={skillOptions}
                                    onSelect={handleSelectSkills}
                                    inputType="checkbox"
                                    checkedItems={selectedSkills}
                                />

                                {selectedSkills?.length > 0 && (
                                    <div className="reportmulselect-blg flex-1 w-full cts-flex1-remd contents flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full">
                                        <div className="inner-reportmulselect-blg items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg mt-2">
                                            {selectedSkills.map((ss: any) => (
                                                <div
                                                    key={ss?.key}
                                                    className="reportmulselect-blg-dv rounded-radius-md1 overflow-hidden flex flex-row items-center justify-start gap-[8px] inner-item-select-dv border-[1px] border-solid border-surface-border dark:bg-slate-700"
                                                >
                                                    <div className="flex flex-row items-center justify-start">
                                                        <div className="relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block dark:text-white">
                                                            {ss?.name}
                                                        </div>
                                                    </div>
                                                    <img
                                                        className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                                        loading="lazy"
                                                        alt="Remove"
                                                        src={closeDowpDowniconimg}
                                                        onClick={() => handleRemoveSkill(ss.key)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Pending Changes Summary for Existing Goals */}
                        {watchGoal === "existing" && Object.keys(taskReplacements).length > 0 && (
                            <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">  Pending Task Reassignments ({Object.keys(taskReplacements).length})</h5>
                        )}

                        {watchGoal === "existing" && Object.keys(taskReplacements).length > 0 && (
                            <div className="self-stretch rounded-lg bg-surface-bg-primary flex flex-col items-start justify-start gap-[8px]  mq575:p-3 task-reassignments-dv">
                                {/* <h4 className="text-sm font-semibold text-blue-800 dark:text-blue-200 mb-2">
                                    Pending Task Reassignments ({Object.keys(taskReplacements).length})
                                </h4> */}

                                <p className="text-xs text-blue-600 dark:text-blue-400 my-0 flex-1 flex">
                                    These changes will be applied when you save the goal.
                                </p>
                                <div className="text-xs text-blue-700 dark:text-blue-300 flex-1 flex">
                                    <p className="my-0 content-reassignments-dv">{Object.entries(taskReplacements).map(([taskId, newAssigneeId]) => {
                                        const task = existingGoalData?.tasks?.find((t: any) => t.id?.toString() === taskId);
                                        const newAssignee = selectedMembers.find(m => m.key === newAssigneeId);
                                        const originalAssignee = existingGoalData?.tasks?.find((t: any) => t.id?.toString() === taskId)?.assigned_to_name;

                                        return (
                                            <div key={taskId} className="mb-1">
                                                "{task?.title}" → {newAssignee?.name} (was: {originalAssignee})
                                            </div>
                                        );
                                    })}</p>
                                </div>
                            </div>
                        )}

                        {watchGoal === "new" && (
                            <h5 className="my-0 font-bold text-xl-dv dark:text-white">Member Tasks</h5>
                        )}

                        {watchGoal === "new" ? (
                            selectedMembers.length === 0 ? (
                                <div className="self-stretch p-4 border border-gray-300 rounded-md bg-gray-50 dark:bg-gray-800 dark:border-gray-600">
                                    <p className="text-gray-600 dark:text-gray-400 text-center">
                                        Please select goal members to add tasks
                                    </p>
                                </div>
                            ) : (
                                <div className="self-stretch flex flex-col gap-4">
                                    {selectedMembers.map((member) => (
                                        <div key={member.key} className="border border-gray-300 rounded-md dark:border-gray-600 addtask-member">
                                            {/* Accordion Header */}
                                            <div
                                                className="flex items-center justify-between accoddion_section  cursor-pointer dark:hover:bg-gray-700 "
                                                onClick={() => toggleMemberAccordion(member.key)}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <span className="dark:text-white plus-cts opacity-45 flex items-center">
                                                        <img
                                                            src={expandedMembers[member.key] ? arrowIconaccordion : downarrowIconaccordion}
                                                            alt="toggle icon"
                                                            className="w-6 h-6 inline-block"
                                                        />
                                                    </span>
                                                    <h6 className="font-semibold text-lg dark:text-white my-0 ">{member.name}</h6>
                                                    <span className="text-sm text-gray-600 dark:text-gray-400">
                                                        ({(memberTasks[member.key] || []).length} task{(memberTasks[member.key] || []).length !== 1 ? 's' : ''})
                                                    </span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            addTaskToMember(member.key);
                                                        }}
                                                        className="py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] text-sm block cursor-pointer flex-col items-center justify-start p-[10px] plus-task-btn taskdash-plush-img rounded gap-[4px]  text-white"
                                                    >
                                                        <img
                                                            className="w-4 h-4 relative overflow-hidden shrink-0 cursor-pointer  top-[3px] dark:top-[3px]"
                                                            loading="lazy"
                                                            alt=""
                                                            src={PlusIcon}
                                                        />
                                                        <span>Add Task</span>
                                                    </button>
                                                    {/* <span className=" dark:text-white plus-cts">
                                                        {expandedMembers[member.key] ? '−' : '+'}
                                                    </span> */}

                                                </div>
                                            </div>

                                            {/* Accordion Content */}
                                            {expandedMembers[member.key] && (
                                                <div className="p-0 pt-[8px] border-t border-gray-300 dark:border-gray-600 members-task-main">
                                                    {(memberTasks[member.key] || []).map((task, taskIndex) => (
                                                        <div key={task.id} className="p-0 border border-gray-200 rounded-md dark:border-gray-700  dark:bg-gray-900">
                                                            <div className="max-w-full inner-addtask-member">

                                                                <div className="flex items-center justify-between mb-8">
                                                                    <h6 className="font-medium text-md dark:text-white my-0">Task {taskIndex + 1}</h6>
                                                                    {(memberTasks[member.key] || []).length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => removeTaskFromMember(member.key, task.id)}
                                                                            className="rounded-[100px] lightred-status-dv border-none bg-transparent flex flex-row items-center justify-center py-2 px-2 text-sm text-white"
                                                                        >
                                                                            <img src={trasBin} className="w-4 h-4" alt="" />
                                                                        </button>
                                                                    )}
                                                                </div>


                                                                <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-4 mb-4">
                                                                    {/* Task Type */}
                                                                    <div className="flex flex-col gap-2">
                                                                        <SearchableInputsDropdown
                                                                            label="Task Type*"
                                                                            initialValue={task.taskType}
                                                                            placeHolder="Select Task Type"
                                                                            options={taskTypeOptions}
                                                                            onSelect={(key: number, name: string) => {
                                                                                updateMemberTask(member.key, task.id, 'taskType', name);
                                                                                updateMemberTask(member.key, task.id, 'taskID', key);

                                                                                // Auto-select all checklist items for every task type
                                                                                const availableChecklists = getTaskChecklistForTask(key.toString());
                                                                                updateMemberTask(member.key, task.id, 'taskChecklist',
                                                                                    availableChecklists.map((item: any) => item.key.toString())
                                                                                );

                                                                                // For goal ID 55: also auto-fill task name
                                                                                if (watchGoalID === "55") {
                                                                                    updateMemberTask(member.key, task.id, 'taskName', name);
                                                                                }

                                                                                // Auto-prefill duration for Meeting / Knowledge Transfer
                                                                                if (name === "Meeting / Knowledge Transfer") {
                                                                                    updateMemberTask(member.key, task.id, 'durationDays', 1);
                                                                                    updateMemberTask(member.key, task.id, 'durationTimeHour', 0);
                                                                                    updateMemberTask(member.key, task.id, 'durationTimeMinute', 0);
                                                                                }
                                                                            }}
                                                                            clearSelected={clearTaskTypeSelected}
                                                                        />
                                                                    </div>

                                                                    {/* Task Name */}
                                                                    <div className="flex flex-col gap-2">
                                                                        <InputsNew
                                                                            label="Task Name*"
                                                                            type="text"
                                                                            contentPlaceholder="Enter task name"
                                                                            value={task.taskName}
                                                                            onChange={(e) => updateMemberTask(member.key, task.id, 'taskName', e.target.value)}
                                                                            disabled={watchGoalID === "55"}
                                                                        />
                                                                    </div>

                                                                    {/* Start Date */}
                                                                    <div className="flex flex-col gap-2">
                                                                        <DateSelector
                                                                            label="Start Date*"
                                                                            selectedDate={task.startTaskDate}
                                                                            onChange={(selectedDate: string | null) => {
                                                                                const goalStartDate = getValues('startGoalDate');
                                                                                const goalEndDate = getValues('endGoalDate');

                                                                                // Validate date is within goal range
                                                                                if (goalStartDate && goalEndDate && selectedDate) {
                                                                                    const taskStart = new Date(selectedDate);
                                                                                    const goalStart = new Date(goalStartDate);
                                                                                    const goalEnd = new Date(goalEndDate);

                                                                                    taskStart.setHours(0, 0, 0, 0);
                                                                                    goalStart.setHours(0, 0, 0, 0);
                                                                                    goalEnd.setHours(23, 59, 59, 999);

                                                                                    // Skip validation if selected date is today
                                                                                    const today = new Date();
                                                                                    today.setHours(0, 0, 0, 0);
                                                                                    const isToday = taskStart.getTime() === today.getTime();

                                                                                    if (!isToday) {
                                                                                        if (taskStart < goalStart) {
                                                                                            showError(`Task start date cannot be before goal start date (${goalStartDate})`);
                                                                                            return;
                                                                                        }

                                                                                        if (taskStart > goalEnd) {
                                                                                            showError(`Task start date cannot be after goal end date (${goalEndDate})`);
                                                                                            return;
                                                                                        }
                                                                                    }
                                                                                }

                                                                                updateMemberTask(member.key, task.id, 'startTaskDate', selectedDate);
                                                                                const endDate = calculateEndDate(selectedDate || '', task.durationDays, task.durationTimeHour, task.durationTimeMinute);
                                                                                updateMemberTask(member.key, task.id, 'endDate', endDate);
                                                                            }}
                                                                            nothideParsedValue={true}
                                                                            blueIcon={true}
                                                                            showAllDate={true}
                                                                        />
                                                                    </div>


                                                                </div>

                                                                {/* Duration */}
                                                                <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-4 mb-4">
                                                                    <div className="flex flex-col gap-2">
                                                                        <InputsNew
                                                                            label="Days*"
                                                                            type="number"
                                                                            contentPlaceholder="1"
                                                                            value={task.durationDays.toString()}
                                                                            onChange={(e) => {
                                                                                const days = Math.max(1, parseInt(e.target.value) || 1);
                                                                                updateMemberTask(member.key, task.id, 'durationDays', days);
                                                                                const endDate = calculateEndDate(task.startTaskDate || '', days, task.durationTimeHour, task.durationTimeMinute);
                                                                                updateMemberTask(member.key, task.id, 'endDate', endDate);
                                                                            }}
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                    <div className="flex flex-col gap-2">
                                                                        <InputsNew
                                                                            label="Hours*"
                                                                            type="number"
                                                                            contentPlaceholder="0"
                                                                            defaultValue={task.durationTimeHour}
                                                                            // value={task.durationTimeHour.toString()}
                                                                            onChange={(e) => {
                                                                                const hours = Math.min(23, Math.max(0, parseInt(e.target.value) || 0));
                                                                                updateMemberTask(member.key, task.id, 'durationTimeHour', hours);
                                                                                const endDate = calculateEndDate(task.startTaskDate || '', task.durationDays, hours, task.durationTimeMinute);
                                                                                updateMemberTask(member.key, task.id, 'endDate', endDate);
                                                                            }}
                                                                            disabled={task.taskType === "Meeting / Knowledge Transfer"}
                                                                        />
                                                                    </div>
                                                                    <div className="flex flex-col gap-2">
                                                                        <InputsNew
                                                                            label="Minutes*"
                                                                            type="number"
                                                                            contentPlaceholder="0"
                                                                            defaultValue={task.durationTimeMinute}
                                                                            // value={task.durationTimeMinute.toString()}
                                                                            onChange={(e) => {
                                                                                const minutes = Math.min(59, Math.max(0, parseInt(e.target.value) || 0));
                                                                                updateMemberTask(member.key, task.id, 'durationTimeMinute', minutes);
                                                                                const endDate = calculateEndDate(task.startTaskDate || '', task.durationDays, task.durationTimeHour, minutes);
                                                                                updateMemberTask(member.key, task.id, 'endDate', endDate);
                                                                            }}
                                                                            disabled={task.taskType === "Meeting / Knowledge Transfer"}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {/* End Date Display */}
                                                                <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-4 mb-4">
                                                                    <div className="flex flex-col gap-2">
                                                                        <InputsNew
                                                                            label="End Date"
                                                                            type="text"
                                                                            contentPlaceholder="-"
                                                                            value={task.endDate || ''}
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {/* Task Checklist */}
                                                                {task.taskType && (
                                                                    <div className="mb-4">
                                                                        <label className="text-sm font-semibold dark:text-white mb-2 block">Task Checklist*</label>
                                                                        {(() => {
                                                                            const availableChecklists = getTaskChecklistForTask(task.taskID);
                                                                            if (availableChecklists.length === 0) {
                                                                                return (
                                                                                    <div className="p-3 bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700 rounded">
                                                                                        <p className="text-red-600 dark:text-red-400 text-sm">
                                                                                            No checklist available for this task type
                                                                                        </p>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return (
                                                                                <div className="border border-gray-300 dark:border-gray-600 rounded p-3">
                                                                                    <div className="mb-2">
                                                                                        <label className="flex items-center gap-2">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={availableChecklists.length > 0 && availableChecklists.every((item: any) => task.taskChecklist.includes(item.key.toString()))}
                                                                                                onChange={(e) => {
                                                                                                    if (watchGoalID === "55") return;
                                                                                                    if (e.target.checked) {
                                                                                                        updateMemberTask(member.key, task.id, 'taskChecklist', availableChecklists.map((item: any) => item.key.toString()));
                                                                                                    } else {
                                                                                                        updateMemberTask(member.key, task.id, 'taskChecklist', []);
                                                                                                    }
                                                                                                }}
                                                                                                disabled={watchGoalID === "55"}
                                                                                            />
                                                                                            <span className="font-semibold text-sm dark:text-white">Select All</span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="grid grid-cols-2 mq575:grid-cols-1 gap-2">
                                                                                        {availableChecklists.map((item: any) => (
                                                                                            <label key={item.key} className="flex items-center gap-2 p-2 border rounded cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={task.taskChecklist.includes(item.key.toString())}
                                                                                                    onChange={(e) => {
                                                                                                        if (watchGoalID === "55") return;
                                                                                                        const currentChecklist = task.taskChecklist;
                                                                                                        if (e.target.checked) {
                                                                                                            updateMemberTask(member.key, task.id, 'taskChecklist', [...currentChecklist, item.key.toString()]);
                                                                                                        } else {
                                                                                                            updateMemberTask(member.key, task.id, 'taskChecklist', currentChecklist.filter((id: string) => id !== item.key.toString()));
                                                                                                        }
                                                                                                    }}
                                                                                                    disabled={watchGoalID === "55"}
                                                                                                />
                                                                                                <span className="text-sm dark:text-white">{item.name}</span>
                                                                                            </label>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })()}
                                                                    </div>
                                                                )}

                                                                {/* Task Skill (Single Selection) */}
                                                                <div className="mb-4">
                                                                    <SearchableInputsDropdown
                                                                        label="Task Skill"
                                                                        initialValue={task.taskSkill}
                                                                        placeHolder={selectedSkills.length === 0 ? "Please select goal skills first" : "Choose"}
                                                                        options={selectedSkills}
                                                                        onSelect={(key: any, name: any) => handleSelectTaskSkill(member.key, task.id, key, name)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )
                        ) : null}


                        <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
                            <button className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                <div className="relative text-sm font-body-xs-semi-bold dark:text-white text-center inline-block">
                                    Cancel
                                </div>
                            </button>
                            <button className={`cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue`}
                                type="submit"
                            >
                                <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                                    Save
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

            </form >
            {(projectsDataLoading || goalsDataLoading || createGoalLoading || existingGoalsDataLoading || ideaDataLoading || goalDetailsLoading || skillLoading || patchDefectLoading || loading) && (
                <Loader />
            )}

            {/* Popup Components for Existing Goal functionality */}
            {showAddMemberPopup && (
                <AddMemberToGoalPopup
                    isOpen={showAddMemberPopup}
                    onClose={() => {
                        setShowAddMemberPopup(false);
                        setEditingMember(null);
                    }}
                    onAddMember={handleAddMember}
                    availableMembers={getAvailableMembers()}
                    goalTypeData={goalTypeData}
                    goalStartDate={watch('startGoalDate')}
                    goalEndDate={watch('endGoalDate')}
                    editingMember={editingMember}
                    existingTasks={editingMember ? memberTasks[editingMember.key] : undefined}
                    allProjectMembers={assignedMemberOptions}
                    existingGoalMembers={selectedMembers}
                    goalSkills={selectedSkills}
                />
            )}

            {showReplaceMemberPopup && memberToReplace && (
                <ReplaceMemberPopup
                    isOpen={showReplaceMemberPopup}
                    onClose={() => {
                        setShowReplaceMemberPopup(false);
                        setMemberToReplace(null);
                    }}
                    onReplaceMember={handleReplaceMemberSubmit}
                    memberToReplace={memberToReplace}
                    memberTasks={getMemberTasksWithStatus(memberToReplace.key)}
                    allProjectMembers={assignedMemberOptions}
                    existingGoalMembers={selectedMembers}
                />
            )}

            {showRemoveConfirmation && memberToRemove && (
                <NotifyPopup
                    showMessage={
                        <div>
                            <div className="mb-3">
                                <strong>{memberToRemove.name}</strong> has <strong>{memberToRemove.reassignedTaskCount}</strong> reassigned task{memberToRemove.reassignedTaskCount !== 1 ? 's' : ''}.
                            </div>
                            <div className="text-sm text-gray-600 dark:text-gray-400">
                                Do you want to revert these tasks to their original assignees and remove the member?
                            </div>
                        </div>
                    }
                    msgHeading="Remove Member with Reassigned Tasks"
                    onsubmit={handleConfirmRemoveMember}
                    back={handleCancelRemoveMember}
                    notDelete={false}
                    isDelete={true}
                />
            )}
        </>
    );
};

export default AddTask;
